export default "__VITE_PUBLIC_ASSET__7a35647f__"